import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito mucha plata para empezar?',
    answer: 'No. La guía está pensada para baja inversión y para que inviertas de forma inteligente, con prioridades claras.'
  }, {
    question: '¿Sirve si recién empiezo en redes?',
    answer: 'Sí. Vas a tener una base simple para publicar y vender sin complicarte.'
  }, {
    question: '¿Y si no soy buena vendiendo?',
    answer: 'Vas a usar mensajes y estructuras (no "técnicas agresivas"). La venta acá es clara y humana.'
  }, {
    question: '¿Cuánto tiempo me lleva?',
    answer: 'Podés avanzar a tu ritmo, pero el plan de 30 días está armado para generar acción constante.'
  }, {
    question: '¿Cómo recibo el producto?',
    answer: 'Acceso digital después del pago (correo / enlace según tu entrega).'
  }, {
    question: '¿Es seguro el pago?',
    answer: 'Sí. Pagás con Mercado Pago.'
  }, {
    question: '¿Necesito experiencia previa?',
    answer: 'No. Este ebook fue creado especialmente para principiantes. Todo está explicado de forma simple y paso a paso.'
  }, {
    question: '¿Sirve en cualquier país?',
    answer: 'Sí. Los principios y estrategias aplican para cualquier país de habla hispana.'
  }, {
    question: '¿Puedo leer el ebook desde mi celular o tablet?',
    answer: 'Sí, completamente. El ebook está en formato PDF digital que puedes leer desde cualquier dispositivo: celular, tablet, computadora o laptop. Lo descargas una vez y lo tienes para siempre.'
  }, {
    question: '¿Hay garantía de devolución?',
    answer: 'Sí. Tienes 7 días de garantía. Si el contenido no cumple tus expectativas, te devolvemos el 100% de tu dinero sin preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 md:py-28 bg-cream-ivory" data-id="element-101">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-103">
          <h2 className="text-4xl md:text-5xl font-extrabold text-coffee-dark mb-4 font-heading" data-id="element-104">
            Preguntas frecuentes
          </h2>
          <div className="w-24 h-1 bg-gold-matte mx-auto rounded-full" data-id="element-105"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-106">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-white rounded-xl border-2 border-beige-sand overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-107">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-108">
                <span className="text-lg font-bold text-coffee-dark font-heading pr-4" data-id="element-109">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0 text-gold-matte bg-beige-sand p-1 rounded-full" data-id="element-110">
                  <ChevronDownIcon className="w-6 h-6" data-id="element-111" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-112">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-113">
                    <div className="px-6 pb-6 text-text-body font-medium border-t border-beige-sand pt-4 mt-2" data-id="element-114">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}